module.exports = __webpack_public_path__ + "static/media/d-and-d.50c866e3.svg";